export const histologyModule = {
  id: "histology",
  title: "Liver histology",
  sections: [
    {
      type: "text",
      content: `<h3>Liver Histology</h3>
      <p>
      The liver is made out of small units called hepatic lobule, 
      that have a central lobule and surrounded
      by a units called portal triads. 
      </p>
      <p><strong>Hepatic Lobule</strong> is divided into:
      <ul>
      <li>Zone 1:</li>
      <li>Zone 2:</li>
      <li>Zone 3: next to the central vein of the lobule.</li>
      </ul>
      <p><strong>Portal triad</strong> is made up of:</p>
       <ul>
      <li>Hepatic artery</li>
      <li>Portal vein</li>
      <li>Bile duct</li>
      </ul>
      </p>

      <div class="highlight-box">
          <strong>Quick Facts:</strong>
          <ul>
            <li>📏 Size: About ,....</li>
            <li>⚖️ Weight: XX grams each</li>
            <li>📍 Location: XXX </li>
            <li>🎨 Color: XX in appearance</li>
          </ul>
        </div>
        ,`,

      image: "/images/liver/liverhisto.png",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "text",
      content: "",
      image: "/images/heart/blood-flow.jpg",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
  ],
};
